import { createSimpleStore } from "@expert/state-utils";

/** Which live realtime websocket the expert's active call is connected to. */
export type RealtimeWebsocketProvider = "gaia" | "simplr";

interface RealtimeWebsocketState {
    /** Provider backing the live realtime connection for the active call. Defaults to GAIA. */
    provider: RealtimeWebsocketProvider;
    setProvider: (provider: RealtimeWebsocketProvider) => void;
}

/**
 * Tracks whether the live realtime websocket for the active call is GAIA or the Simplr cutover
 * (`isSimplrWebsocketLiveEnabled`, Staples pilot). Written from {@link PartnerAwareWebsocketProvider}
 * and read by the timeline so the migration can surface a visible "Simplr" badge — the frontend is
 * otherwise identical whichever provider serves Expert Assist.
 */
export const useRealtimeWebsocketStore = createSimpleStore<RealtimeWebsocketState>({
    devtools: {
        store: "realtime-websocket",
        name: "workspace/realtime-websocket",
        isProd: import.meta.env.VITE_ENV_TYPE === "production",
    },
})((set) => ({
    provider: "gaia",
    setProvider: (provider) => set({ provider }, false, "setProvider"),
}));
